
export const BOOKING_CAPS_KEY = 'booking-caps'

// A cap for the API: blank -> null, otherwise a whole number in [0, 50].
export function cleanCap (v) {
    if (v === null || v === undefined || v === '' || isNaN(v)) return null
    return Math.min(50, Math.max(0, Math.trunc(Number(v))))
}

export default {
    data () {
        return {
            loading: true,
            saving: false,
            form: { total: null, regular: null, aep: null },
        }
    },
    computed: {
        summary () {
            const parts = [
                ['Total', this.form.total],
                ['Regular', this.form.regular],
                ['AEP', this.form.aep],
            ].filter(([, v]) => cleanCap(v)).map(([k, v]) => `${k} ${cleanCap(v)}`)
            return parts.length ? parts.join(' · ') : 'No defaults set: agents without their own cap are uncapped.'
        },
    },
    async mounted () {
        await this.load()
    },
    methods: {
        async load () {
            this.loading = true
            try {
                const setting = await this.$api.getSetting({ key: BOOKING_CAPS_KEY })
                const value = (setting && setting.value) || {}
                this.form = {
                    total: cleanCap(value.total),
                    regular: cleanCap(value.regular),
                    aep: cleanCap(value.aep),
                }
            } catch (e) {
                this.toast(`Failed to load booking cap defaults: ${e.message || e}`, 'danger')
            }
            this.loading = false
        },
        payload () {
            return {
                total: cleanCap(this.form.total),
                regular: cleanCap(this.form.regular),
                aep: cleanCap(this.form.aep),
            }
        },
        async save () {
            this.saving = true
            try {
                const setting = await this.$api.setSetting({ key: BOOKING_CAPS_KEY, value: this.payload() })
                const value = (setting && setting.value) || this.payload()
                this.form = { total: cleanCap(value.total), regular: cleanCap(value.regular), aep: cleanCap(value.aep) }
                this.toast('Booking cap defaults saved. They now apply to every agent without their own cap.', 'success')
            } catch (e) {
                this.toast(`Failed to save booking cap defaults: ${e.message || e}`, 'danger')
            }
            this.saving = false
        },
        toast (message, variant) {
            if (this.$bvToast && this.$bvToast.toast) {
                this.$bvToast.toast(message, { variant })
            }
        },
    },
}
